module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2v60c"))).then(() => module.bundle.root('37nVf'));